import pull from 'lodash/pull';

type Listener = (value: any) => void;

const localStorageListenersByKey: Record<string, Listener[]> = {};

type RemoveListener = () => void;

export function listenLocalStorage(key: string, listener: Listener): RemoveListener {
  const listeners = localStorageListenersByKey[key] || [];
  localStorageListenersByKey[key] = listeners;
  listeners.push(listener);
  return () => {
    pull(listeners, listener);
  };
}

export function readLocalStorage<T>(key: string, parseJson = true): T | undefined {
  try {
    const encodedValue = localStorage.getItem(key);
    if (encodedValue != null) {
      return (parseJson ? JSON.parse(encodedValue) : encodedValue) as T;
    }
  } catch {
    // Cannot read from the storage
  }
  return undefined;
}

export function writeLocalStorage(key: string, value: any, encodeJson = true) {
  try {
    if (typeof value === 'undefined') {
      localStorage.removeItem(key);
    } else {
      const encodedValue = encodeJson ? JSON.stringify(value) : value;
      localStorage.setItem(key, encodedValue);
    }
  } catch {
    // Cannot store the value
  }
  // Trigger the listeners
  const listeners = localStorageListenersByKey[key] || [];
  listeners.forEach((listener) => listener(value));
}
